import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";

const BookTimeCard: FunctionComponent = ({}) => {
    const navigate = useNavigate();

    const handleClick = (to: string) => {
      navigate(to);
};
  return (
    <>
      <div className="flex justify-center flex-col text-center">
        <div className="bg-indigo w-full max-md:h-[150px] h-[210px] absolute"></div>
        <img
          className="w-[calc(100%+1px)] max-md:mt-[170px] mt-[350px] absolute"
          alt="Wave til book tid"
          title="Wave til book tid"
          src="../vector87.svg"
          loading="lazy"
        />
        <div className="self-center flex flex-col justify-center -mb-20">
          <h2 className="text-2xl max-md:text-sm self-center absolute max-md:pb-32 pb-16 w-full">
            Book tid til en konsultation
          </h2>
          <div className="flex gap-3 pt-[5rem] max-md:pt-6 self-center absolute">
            
              <button onClick={() => handleClick("/priser")} className="cursor-pointer rounded-lg border-none bg-white hover:bg-slate-200 text-indigo font-bold  max-md:py-1 max-md:px-6 py-3 px-11">
                Se priser
              </button>
              <button
                 onClick={() => handleClick("/kontakt")}
                type="button"
                className="cursor-pointer rounded-lg border-white bg-indigo hover:bg-[#7d406c] text-white font-bold max-md:py-1 max-md:px-4 py-3 px-8"
              >
                Kontakt mig
              </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookTimeCard;
